module.exports = __webpack_public_path__ + "media/sounds/correct_answer_1-21a525dcec3f9ab9120971c7b3c00f80.mp3";